import React from 'react'
import { stringify } from 'utils/json'

const Pre = ({ style = {}, children }) => (
  <pre
    style={{
      background: 'white',
      margin: '0',
      padding: '10px',
      overflow: 'scroll',
      minHeight: '5rem',
      maxWidth: '50rem',
      maxHeight: '50rem',
      fontSize: '0.7rem',
      resize: 'both',
      ...style,
    }}
  >
    {children}
  </pre>
)

export const Debug = ({
  style,
  ...props
}: { style?: React.CSSProperties } & Record<string, unknown>) => {
  const data = stringify(props, null, 2)
  return <Pre style={style}>{data}</Pre>
}
